import { render, staticRenderFns } from "./CommercialProductForm.vue?vue&type=template&id=b4443ace&scoped=true&"
import script from "./CommercialProductForm.vue?vue&type=script&lang=js&"
export * from "./CommercialProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4443ace",
  null
  
)

export default component.exports